import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

// Создаем контекст
const ChecklistContext = createContext();

// Провайдер контекста
export const ChecklistProvider = ({ children }) => {
    const [completedZones, setCompletedZones] = useState([]);
    const [zoneCounts] = useState({});
    const [zonePhotos, setZonePhotos] = useState({});

    const addCompletedZone = (zoneId, zoneName) => {
        setCompletedZones((prevZones) => {
            // Фильтруем уже добавленные зоны по типу (например, "bedroom")
            const existingZones = prevZones.filter(zone => zone.id.startsWith(zoneId));
            console.log('existingZones:', existingZones);
            // Если уже есть зона с таким id и номером, не добавляем дубликат
            const newZoneNumber = existingZones.length + 1;
            const newZoneId = `${zoneId}-${newZoneNumber}`;

            // Проверяем, существует ли зона с таким уникальным ID
            if (prevZones.some(zone => zone.id === newZoneId)) {
                return prevZones; // Если зона уже существует, выходим без изменений
            }

            // Добавляем новую зону
            return [...prevZones, { id: newZoneId, name: `${zoneName} ${newZoneNumber}` }];
        });
    };




    const addZonePhotos = (zoneId, photos) => {
        setZonePhotos((prevPhotos) => ({
            ...prevPhotos,
            [zoneId]: photos,
        }));
    };

    return (
        <ChecklistContext.Provider value={{ completedZones, addCompletedZone, zoneCounts, zonePhotos,addZonePhotos  }}>
            {children}
        </ChecklistContext.Provider>
    );
};

// Проптайпы для children
ChecklistProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Хук для использования контекста
export const useChecklist = () => {
    return useContext(ChecklistContext);
};
